import React, { useState } from 'react';
import DataTable from '../ui/DataTable';
import { useNavigate } from 'react-router-dom';
import { FaEye, FaSync } from 'react-icons/fa';
import PropTypes from 'prop-types';
import PaymentVerificationModal from '../payment/PaymentVerificationModal';

const ApplicationTable = ({
    data = [],
    refreshData,
    pageSize = 10,
    totalItems = 0,
    totalPages = 0,
    page = 1,
    onPageChange,
    searchTerm = '',
    onSearchChange,
    loading = false
}) => {
    const navigate = useNavigate();
    const [verificationModal, setVerificationModal] = useState({ show: false, orderId: null });

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const options = { year: 'numeric', month: 'short', day: 'numeric' };
        return new Date(dateString).toLocaleDateString(undefined, options);
    };

    const columns = [
        {
            key: 'serial',
            label: 'SL No',
            sortable: false,
            render: (_, row, index) => (page - 1) * pageSize + index + 1
        },
        { key: 'applicationNo', label: 'Application No' },
        { key: 'name', label: 'Full Name' },
        { key: 'email', label: 'Email' },
        { key: 'contact', label: 'Contact' },
        { key: 'level', label: 'Level' },
        {
            key: 'createdAt',
            label: 'Submitted At',
            render: (value) => formatDate(value)
        },
        { key: 'payment.orderId', label: 'Order ID' },
        {
            key: 'payment.gateway',
            label: 'Gateway',
            render: (v) => v ? (v === 'cashfree' ? 'Cashfree' : 'Easebuzz') : 'Cashfree'
        },
        { key: 'payment.status', label: 'Status' }
    ];

    const actions = [
        {
            label: 'View',
            icon: <FaEye />,
            variant: 'info',
            onClick: (item) => navigate(`/application/${item._id}`),
            tooltip: 'View application details'
        },
        {
            label: 'Verify',
            icon: <FaSync />,
            variant: 'outline-warning',
            tooltip: 'Verify payment status',
            show: (item) => item.payment?.status !== 'SUCCESS',
            onClick: (item) => {
                if (!item.payment?.orderId) {
                    alert('Order ID not found for this application');
                    return;
                }
                setVerificationModal({ show: true, orderId: item.payment.orderId });
            }
        }
    ];

    return (
        <>
            <DataTable
                columns={columns}
                data={data}
                actions={actions}
                searchable={true}
                searchTerm={searchTerm}
                onSearchChange={onSearchChange}
                pagination={true}
                pageSize={pageSize}
                striped={true}
                hover={true}
                bordered={true}
                responsive={true}
                className="mt-3"
                serverSide={true}
                totalItems={totalItems}
                totalPages={totalPages}
                page={page}
                onPageChange={onPageChange}
                emptyMessage={loading ? 'Loading...' : 'No applications found'}
            />

            <PaymentVerificationModal
                show={verificationModal.show}
                onHide={() => setVerificationModal({ show: false, orderId: null })}
                orderId={verificationModal.orderId}
                onSuccess={refreshData}
            />
        </>
    );
};

ApplicationTable.propTypes = {
    data: PropTypes.array,
    refreshData: PropTypes.func,
    pageSize: PropTypes.number,
    totalItems: PropTypes.number,
    totalPages: PropTypes.number,
    page: PropTypes.number,
    onPageChange: PropTypes.func,
    searchTerm: PropTypes.string,
    onSearchChange: PropTypes.func,
    loading: PropTypes.bool
};

ApplicationTable.defaultProps = {
    pageSize: 10
};

export default ApplicationTable;